import React, { FC } from 'react';
import { CommodityCardListProps } from './types';
import { Box } from '@bechtel/gds';
import { map, groupBy, sortBy } from 'lodash';
import { CommodityCard } from './card';
import { DND_IDENTIFIER } from '@bechtel/client-common';

export const CommodityCards: FC<CommodityCardListProps> = ({
  commodityMilestones,
  droppableId,
  selectedMilestoneDraggableIds,
  setSelectedMilestoneDraggableIds,
  draggingMilestoneId,
  milestoneIdentifiers,
}) => {
  const sortedCommodityList = sortBy(commodityMilestones, (milestone) => {
    return (milestone.commodity.materialCommodity || milestone.commodity.weld)?.tag;
  });
  //Note: Grouped by id for commodity card drag & drop scenario
  const milestoneList = groupBy(sortedCommodityList, (milestone) => {
    return (milestone.commodity.materialCommodity || milestone.commodity.weld)?.id;
  });

  return (
    <Box
      style={{ width: '100%' }}
      flexDirection={{ sm: 'column' }}
      alignSelf={{ sm: 'baseline' }}
      data-testid="commodity-card-wrapper"
    >
      {milestoneList &&
        map(Object.keys(milestoneList), (key, index) => {
          const milestones = milestoneList[key];
          milestones.sort(function (a, b) {
            return Number(a.isExpired) - Number(b.isExpired);
          });
          const identifier = `${droppableId}___${DND_IDENTIFIER.Commodity}___${key}`;
          return (
            <CommodityCard
              key={identifier}
              commodityMilestones={milestones}
              droppableId={droppableId}
              draggableId={identifier}
              dragIndex={index}
              commodityId={key}
              setSelectedMilestoneDraggableIds={setSelectedMilestoneDraggableIds}
              selectedMilestoneDraggableIds={selectedMilestoneDraggableIds}
              draggingMilestoneId={draggingMilestoneId}
              milestoneIdentifiers={milestoneIdentifiers}
            />
          );
        })}
    </Box>
  );
};

export default CommodityCards;
